$(document).ready(function () {
    function normalizeRelatedSize(value) {
        return (value || '').toString().trim().toLowerCase();
    }
    
    function updateRelatedProductsBySize(sizeName) {
        var normalizedSize = normalizeRelatedSize(sizeName);
    
        $('.relatedProducts .rl-add-to-cart-btn').text('ADD TO BASKET');
    
        $('.productitem').each(function () {
            var $item = $(this);
            var isMattressItem = $item.attr('data-is-mattress') === 'true';
    
            if (!isMattressItem || normalizedSize === '') {
                $item.show();
                return;
            }
    
            var hasMatchingAvailableSize = false;
            $item.find('.rl-sizes select option').each(function () {
                if (
                    normalizeRelatedSize($(this).text()) === normalizedSize &&
                    !$(this).prop('disabled')
                ) {
                    hasMatchingAvailableSize = true;
                    return false;
                }
            });
    
            if (hasMatchingAvailableSize) {
                $item.show();
                $item.find('.rl-sizes select option').each(function () {
                    if (
                        normalizeRelatedSize($(this).text()) === normalizedSize &&
                        !$(this).prop('disabled')
                    ) {
                        $(this).closest('select').val($(this).val()).trigger('change');
                        return false;
                    }
                });
            } else {
                $item.hide();
            }
        });
    
        if ($('.productitem:visible').length === 0) {
            $('.rl-heading').addClass('hide');
        } else {
            $('.rl-heading').removeClass('hide');
        }
    }
    
    function isSizeSwatchRadio($radio) {
        var swatchType = ($radio.data('swatch') || '').toString().toLowerCase();
        return (
            swatchType.indexOf('size') !== -1 ||
            swatchType.indexOf('model') !== -1 ||
            swatchType.indexOf('style') !== -1
        );
    }

    function syncMattressRlSelectBySize(variantName) {
        if (!variantName) return;

        var normalizedVariant = normalizeRelatedSize(variantName);
        $('.rl-sizes select option').each(function () {
            if (
                normalizeRelatedSize($(this).text()) === normalizedVariant &&
                !$(this).prop('disabled')
            ) {
                var price = $(this).attr('rl-price');
                $(this).closest('select').val($(this).val()).trigger('change');
                $(this)
                    .parents('.productitem')
                    .find('.rl-product-item-regular-price')
                    .text(price);
            }
        });
        updateRelatedProductsBySize(variantName);
    }

    window.__daalsSyncMattressRelatedSize = syncMattressRlSelectBySize;

    updateRelatedProductsBySize(initialRelatedSize);

    $(document).on('click', '[id^="ProductSection-"] .swatch-radio', function () {
        var $radio = $(this);
        if (!isSizeSwatchRadio($radio)) return;
        syncMattressRlSelectBySize(
            ($radio.data('value') || $radio.val() || '').toString().trim()
        );
    });
    
	let breakForPoll = 0;

	//////// Functionality for click video button ///////////////
	(function pollForHotspot() {
		if (window.jQuery !== undefined && $('.pd-img-slide-video').length > 0) {
			$('.video_productpage_galery').removeClass('hide');
			$('.video_productpage_galery').click(function () {
				var indexNumber = $('.pd-img-slide-video').parent().data('slick-index');
				$('.rt-fastor-product-gallery__wrapper').slick(
					'slickGoTo',
					parseInt(indexNumber),
					false
				);
			});
		} else if (++breakForPoll < 3000) {
			setTimeout(pollForHotspot, 25);
		}
	})();

	$('.productitem .rl-add-to-cart-btn').click(function () {
		let skuId = $(this).parents('.productitem').find('.rl-sizes select').val();
		let frequentlyProductContainer = $(this).parents('.productitem');
		let button = $(this);
		button.text('ADDING...');
		if (window.shopping_cart_type == 'sidebar') {
			window.roar.openCartSidebarWithSkeleton();
		}
		button.text('ADDING...');
		var addToCartRequest = function (data) {
			$.ajax({
				method: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: data,
			}).done(function (resp) {
				button.text('ADDED');
				window.shopping_cart_type == 'sidebar'
					? window.roar.updateCartSidebar('add_to_cart_function', !0)
					: window.roar.updateCart(button, !0);
				frequentlyAtcEventKlaviyo(frequentlyProductContainer);
			});
		};
		if ($(this).parents('.productitem').attr('rl-cart-properties')) {
			let preorderNote = $(this)
				.parents('.productitem')
				.attr('rl-cart-properties');
			setTimeout(function () {
				addToCartRequest({
					quantity: 1,
					id: skuId,
					properties: {
						'Please-Note': preorderNote,
					},
				});
			}, 0);
		} else {
			setTimeout(function () {
				addToCartRequest({
					quantity: 1,
					id: skuId,
				});
			}, 0);
		}
	});

	// Klaviyo ATC Button

	function frequentlyAtcEventKlaviyo(frequentlyProductContainer) {
		let qvPdName = frequentlyProductContainer
			.find('.rl-product-item-title')
			.text();
		let qvPdPrice = frequentlyProductContainer
			.find('.rl-product-item-regular-price')
			.text();
		let qvPdId = frequentlyProductContainer.attr('pd_id');
		let url = frequentlyProductContainer
			.find('.rl-product-item-title')
			.attr('href');
		let imageURL = frequentlyProductContainer
			.find('.rl-product-item-main-image')
			.attr('src');

		let item = {
			Name: qvPdName,
			ProductID: qvPdId,
			Categories: 'Frequently bought together product',
			ImageURL: 'https:' + imageURL,
			URL: 'https://www.daals.co.uk' + url,
			Brand: 'daals',
			Price: qvPdPrice,
		};
		_learnq.push(['track', 'Added to Cart', item]);
	}

	//SELECT SIZE
	function preorderAvailability(date) {
		var dateParts = date.split('-');
		// Extract the year, month, and day
		var year = dateParts[0];
		var monthNumber = dateParts[1];
		var day = dateParts[2];

		// Convert the month number to the month name
		const months = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];

		var monthName = months[parseInt(monthNumber) - 1];

		// Determine the day suffix (st, nd, rd, or th)
		var daySuffix = getDaySuffix(parseInt(day));

		// Format the date string
		var formattedDate =
			parseInt(day) + daySuffix + ' ' + monthName + ' ' + year;

		// Function to get the day suffix
		function getDaySuffix(day) {
			if (day >= 11 && day <= 13) {
				return 'th';
			} else {
				switch (day % 10) {
					case 1:
						return 'st';
					case 2:
						return 'nd';
					case 3:
						return 'rd';
					default:
						return 'th';
				}
			}
		}
		return formattedDate;
	}

	$('.rl-sizes select')
		.change(function () {
			let price = $(this).find('option:selected').attr('rl-price');
			$(this)
				.parents('.productitem')
				.find('.rl-product-item-regular-price')
				.text(price);
			$(this)
				.parents('.productitem')
				.find('.rl-add-to-cart-btn')
				.text('ADD TO BASKET');
			var dateArray = $(this)
				.find('option:selected')
				.attr('preorder-availability');
			if (typeof dateArray !== 'undefined' && dateArray.length > 0) {
				try {
					var dateString = dateArray.trim(); // Get the date string from the array
					var date = preorderAvailability(dateString);
					$(this)
						.parents('.productitem')
						.attr('rl-cart-properties', 'ready for delivery from ' + date);
					$(this).parents('.productitem').removeClass('preorder-active');
					$(this).parents('.productitem').addClass('preorder-active');
				} catch (error) {
					console.error('Error parsing dateArray:', error);
				}
			} else {
				$(this).parents('.productitem').attr('rl-cart-properties', '');
				if ($(this).parents('.productitem').hasClass('preorder-active')) {
					$(this).parents('.productitem').removeClass('preorder-active');
				}
			}
		})
		.change();

	$('.productitem').length == 0 && $('.rl-heading').addClass('hide');
	var selectList = $('.rl-sizes select option:selected');
	var price;
	$.each(selectList, function (i, val) {
		price = $(this).attr('rl-price');
		$(this)
			.parents('.productitem')
			.find('.rl-product-item-regular-price')
			.text(price);
	});

	// Inject product title into Yotpo review modal header on open
	$(document).on('click', '#yotpo-main-widget-btn', function () {
		const productTitle = $('.summary .name').text();

		(function pollForYotpoTitle() {
			const startTime = Date.now();
			const maxDuration = 5000; // 5 seconds

			function check() {
				if ($('header .yotpo-modal-header').length > 0) {
					$('header .yotpo-modal-header').text(
						'Write a review for ' + productTitle
					);
				}

				if (Date.now() - startTime < maxDuration) {
					setTimeout(check, 25);
				}
			}

			check();
		})();
	});
	// HIDE STAR RATING WHEN IT IS EQUAL TO 0 - Start
    function customReviewDesign(hasReview = false) {
        const viewportWidth = window.innerWidth;
        if (hasReview) {
            if (!$('.review').hasClass('review-as-inline-block')) {
                $('.review').addClass('review-as-inline-block');
            }
    
            if (!$('.range-link').hasClass('range-link-flex')) {
                $('.range-link').addClass('range-link-flex');
            }
        } else {
            var titleHeight = $('.name').height();
            var lineHeight = parseInt($('.name').css('line-height'));
    
            if (titleHeight > lineHeight * 1.5) {
                // If the title occupies more than one line
                $('.name').css({
                    display: 'inline',
                });
    
                $('.range-link').css({
                    display: viewportWidth > 960 ? 'inline-flex' : 'flex',
                    'margin-left': viewportWidth > 960 ? '79px' : '0px',
                    'margin-top': '2px',
                });
            } else {
                // If the title is one line
                $('.range-link').css({
                    display: 'flex',
                    'margin-left': '0px',
                    'margin-bottom': '13px',
                });
            }
        }
        if (!$('.range-link').hasClass('visible-range-link')) {
            $('.range-link')
                .addClass('visible-range-link')
                .css('visibility', 'visible');
        }
        if ($('.range-link').length) {
            if (!$('.review').hasClass('review-with-right-border')) {
                $('.review').addClass('review-with-right-border');
            }
        }
    }
    
    function checkStars() {
        if ($('.yotpo-stars').length > 0) {
            if ($('.review .yotpo-stars span.yotpo-icon-star').length > 0) {
                $('.review').css('display', 'block');
                customReviewDesign(true);
            } else {
                customReviewDesign(true);
            }
        } else {
            setTimeout(checkStars, 25);
        }
    }
    
    checkStars();  
    // HIDE STAR RATING WHEN IT IS EQUAL TO 0 - End
});
